import { render, staticRenderFns } from "./Scene13.vue?vue&type=template&id=20510c78&scoped=true"
import script from "./Scene13.vue?vue&type=script&lang=js"
export * from "./Scene13.vue?vue&type=script&lang=js"
import style0 from "./Scene13.vue?vue&type=style&index=0&id=20510c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20510c78",
  null
  
)

export default component.exports